export enum EIconName {
  Music = "Music",
  Composer = "Composer",
  Science = "Science",
  Physics = "Physics",
  Writer = "Writer",
  Poet = "Poet",
  Politics = "Politics",
  Military = "Military",
}

export enum EIconName2 {
  Tanks = "tanks",
  Aircraft = "aircraft",
  Troops = "troops",
  Artillery = "artillery",
  Ships = "ships",
}

export enum EHeaderIconName {
  trending = "trending",
  article = "article",
  setting = "setting",
  notification = "notification",
  voice = "voice",
  stats = "stats",
}

export enum EColors {
  green = "green",
  red = "red",
  blue = "blue",
  yellow = "yellow",
  orange = "orange",
  cyan = "cyan",
}
